module.exports = __webpack_public_path__ + "img/conservative-practitioner-4.d9409dd7.svg";